angular.module('aprima-core-ui').factory('BarcodeScanningService',
    ['Bridge',
        function (Bridge) {
            'use strict';
            var id = 0;

            function scanBarcode (scope, scanResultCallback) {
                var barcodeId = id++;
                Bridge.scanBarcode(barcodeId);

                var unregister = Bridge.on('scannedBarcodeResult', scope, function (value) {
                    unregister();

                    if (parseInt(value.Id) === barcodeId) {
                        scanResultCallback(value.StatusMessage, value.ScannedResultText);
                    }
                });
            }

            return {
                scanBarcode: scanBarcode
            };
        }
    ]
);